<template>
  <c-input
    as="multiselect"
    class="multiselect-multiple"
    multiple
    v-model="selectedTags"
    :placeholder="holder"
    :close-on-select="false"
    :preselect-first="false"
    :show-labels="false"
    :options="mediaOwnerScreenTags"
    label="name"
    track-by="id"
  />
</template>

<script>
import { get, call } from 'vuex-pathify'

export default {
  props: {
    value: Array,
    holder: {
      default: 'Select'
    }
  },

  data () {
    return {
      tagOptions: []
    }
  },

  computed: {
    ...get('lists/mediaOwnerScreenTags', ['mediaOwnerScreenTags']),

    selectedTags: {
      get () {
        const ids = this.value.map(({ id }) => id)

        return this.mediaOwnerScreenTags.filter(({ id }) => {
          return ids.includes(id)
        })
      },

      set (options) {
        this.$emit('input', options)
      }
    }
  },

  methods: {
    getMediaOwnerScreenTags: call('lists/mediaOwnerScreenTags/getMediaOwnerScreenTags')
  },

  async created () {
    this.getMediaOwnerScreenTags()
  }
}
</script>
